module.exports = __webpack_public_path__ + "static/media/sightnight-3.d14fc2cf.jpg";